<app-loader [isLoading]="loading"></app-loader>
<div>
    <router-outlet></router-outlet>
</div>
<app-toaster></app-toaster>
